import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {isApiResponseOk} from '../../util/utils';

export function deficienciesReducer(state = initialstate.deficiencies, action) {
	switch (action.type) {
		case types.GET_ALL_DEFICIENCIES:
		case types.LIST_DEFICIENCIES: {
			if (!isApiResponseOk(action)) {
				return state;
			}
			return action.response || state;
		}
		case types.CREATE_DEFICIENCY:
			if (!isApiResponseOk(action)) {
				return state;
			}
			if (action.actionArgs.updateState && action.response) {
				let newState;
				const responseData = Array.isArray(action.response) ? action.response[0] : action.response;

				if (Object.keys(state).length === 0) {
					newState = {
						data: [responseData],
						lastCreatedDeficiency: responseData
					};
				} else {
					newState = {
						...state,
						data: [...state.data, responseData],
						lastCreatedDeficiency: responseData
					};
				}
				return newState;
			}
			const responseData = Array.isArray(action.response) ? action.response[0] : action.response;
			return {...state, lastCreatedDeficiency: responseData};
		case types.UPDATE_DEFICIENCY:
			if (!isApiResponseOk(action) || !action.response || !state.data) {
				return state;
			}
			const updatedDeficiencies = state.data.map((deficiency) =>
				deficiency.id === action.response.id
					? {
							...deficiency,
							deficiencyShortName: action.response.deficiencyShortName,
							description: action.response.description
						}
					: deficiency
			);

			return {
				...state,
				data: updatedDeficiencies
			};
		case types.DELETE_DEFICIENCY:
			if (!isApiResponseOk(action) || !action.payload || !state.data) {
				return state;
			}
			const filteredDeficiencies = state.data.filter((deficiency) => deficiency.id !== action.payload.deficiencyId);
			return {
				...state,
				data: filteredDeficiencies
			};
		case types.UPDATE_DEFICIENCIES_STORE_BY_ID: {
			if (!action.response || !state?.data || !Array.isArray(state.data)) return state;
			const updatedData = state.data.map((deficiency) => (deficiency.id === action.response.id ? {...deficiency, ...action.response} : deficiency));
			return {...state, data: updatedData};
		}
		case types.CLEAR_DEFICIENCIES_LIST:
			return {...state, data: [], page: 1, pages: 1, totalEntityCount: 0};
		case types.CLEAR_LAST_CREATED_DEFICIENCY:
			return {...state, lastCreatedDeficiency: null};
		default:
			return state;
	}
}
